export default "__VITE_ASSET__Cis$J2GM__"